
import { Vue } from "vue-class-component";

export default class FontStroke extends Vue {
  strokeWidths = [0, 1, 2, 3, 4, 5, 6];

  changeColor(strokeColor: string) {
    this.$store.commit("setFontStrokeColor", strokeColor);
  }

  changeWidth(strokeWidth: string) {
    this.$store.commit("setFontStrokeWidth", strokeWidth);
  }
}
